export default __webpack_public_path__ + "static/media/emailIcon.80999132.svg";